export const HEADS_UP_ID = 'blm';
export const HEADS_UP_ID_SECOND = 'cv19-2';
